/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Add_ImageInputs */

const vi_product_add_image = /** @type {(inputs: Product_Add_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm ảnh sản phẩm`)
};

/**

* @param {Product_Add_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_add_image = /** @type {((inputs?: Product_Add_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Add_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_add_image(inputs)
});